var _path, _path2, _path3, _path4, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendorIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3746 2.05176C36.8729 2.05391 34.4743 3.04815 32.7047 4.81542C30.9352 6.5827 29.9389 8.98134 29.9346 11.4831C30.4521 23.9939 48.2885 23.9917 48.797 11.4831C48.7927 8.98354 47.8006 6.58924 46.0333 4.82202C44.2682 3.05474 41.874 2.05824 39.3746 2.05176Z",
    fill: "#294DD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3912 43.5479H0.723887L0.698118 45.6179V45.6158C0.689528 46.7711 1.14263 47.8834 1.95436 48.7037C2.7661 49.5262 3.87199 49.99 5.02725 49.9965H33.6628C32.0801 48.416 32.4019 45.6134 32.3912 43.5479Z",
    fill: "#294DD8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2249 15.6486C40.7252 15.7581 41.2492 15.6336 41.6464 15.3136C42.0458 14.9915 42.2777 14.5062 42.2777 13.9951C42.2777 13.4841 42.0458 12.9988 41.6464 12.6767C41.2491 12.3567 40.7252 12.2322 40.2249 12.3417V15.6486Z",
    fill: "#294DD8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4649 2.04295L9.18215 2H9.18429C6.79423 1.99785 4.8573 3.93264 4.85516 6.32056L4.8208 41.8277L33.2502 41.8299C33.4778 41.8277 33.6968 41.9179 33.86 42.0789C34.0211 42.24 34.1113 42.459 34.1091 42.6888V46.5885V46.5864C34.0662 48.3901 35.462 49.8998 37.2615 49.9964C38.114 50.0028 38.9322 49.6721 39.5377 49.073C40.1433 48.4761 40.4869 47.6622 40.4912 46.8097V22.5786C40.1218 22.613 39.7439 22.6301 39.3659 22.6301C28.1289 22.5249 24.0914 7.95476 33.4649 2.04295ZM35.6037 25.1405C36.0739 25.1469 36.4498 25.5291 36.4498 25.9994C36.4498 26.4675 36.074 26.8498 35.6037 26.8584H9.90592C9.43564 26.8498 9.05983 26.4675 9.05983 25.9994C9.05983 25.5291 9.43562 25.1469 9.90592 25.1405H35.6037ZM9.90592 10.4093H25.3995C25.8698 10.4158 26.2456 10.798 26.2456 11.2683C26.2456 11.7385 25.8699 12.1208 25.3995 12.1272H9.90592C9.43564 12.1208 9.05983 11.7385 9.05983 11.2683C9.05983 10.798 9.43562 10.4157 9.90592 10.4093ZM9.90592 17.7708H27.3577C27.8258 17.7794 28.2016 18.1616 28.2016 18.6297C28.2016 19.0978 27.8258 19.4801 27.3577 19.4887H9.90592C9.43564 19.4822 9.05983 19.0978 9.05983 18.6297C9.05983 18.1594 9.43562 17.7772 9.90592 17.7708ZM35.6059 34.2286H9.90592C9.43564 34.22 9.05983 33.8378 9.05983 33.3697C9.05983 32.8994 9.43562 32.5171 9.90592 32.5107H35.6037C36.0739 32.5172 36.4498 32.8994 36.4498 33.3697C36.4498 33.8378 36.074 34.22 35.6037 34.2286H35.6059Z",
    fill: "#294DD8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_2295_16816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7136 9.23695L42.3955 10.3597H36.4365L36.7546 9.23695H42.7136ZM39.8137 16.3096L36.5592 12.3596L36.5501 11.4733H38.1637C38.5667 11.4733 38.9076 11.4112 39.1864 11.2869C39.4652 11.1627 39.6773 10.9824 39.8228 10.746C39.9682 10.5066 40.041 10.2157 40.041 9.8733C40.041 9.36422 39.8894 8.95968 39.5864 8.65968C39.2834 8.35969 38.8092 8.20969 38.1637 8.20969H36.4365L36.7683 7.00061H38.1637C38.9152 7.00061 39.5349 7.12031 40.0228 7.3597C40.5106 7.59909 40.8743 7.9309 41.1137 8.35514C41.3531 8.77938 41.4728 9.26876 41.4728 9.8233C41.4728 10.3172 41.3743 10.7642 41.1773 11.1642C40.9803 11.5642 40.6667 11.8899 40.2364 12.1414C39.8061 12.393 39.241 12.5399 38.541 12.5824L38.5001 12.5914L41.4728 16.2323V16.3096H39.8137ZM42.7182 7.00061L42.3955 8.13242L37.6319 8.10514L37.9546 7.00061H42.7182Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_2295_16816",
    x: 5.91353,
    y: -23.522,
    width: 67.3277,
    height: 70.3546,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15.2615
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2295_16816"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.58396
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.30661
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.995833 0 0 0 0 0.456424 0 0 0 0 0.611217 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2295_16816",
    result: "effect2_dropShadow_2295_16816"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2295_16816",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorIcon);
export default __webpack_public_path__ + "static/media/vendorIcon.eb318245d73766c01f22f3a3af637de3.svg";
export { ForwardRef as ReactComponent };